module.exports = __webpack_public_path__ + "img/hongbao_img02.5600984a.png";